import React, { Component } from 'react';
import billMoment from 'moment';
import DagreChart from '../DagreChart';
import Table from '../Table';
import Modal from '../Modal';
import Button from '../Button';
import ButtonGroup from '../ButtonGroup';
import Tooltip from '../Tooltip';
import HotKeys from '../HotKeys';
import { ellipsisText } from './util';
// import MaxBox from '../MaxBox'
import { ajax, toast, pageTo, getAppUrl, getSysFieldid, getTopWindow } from '@platform/api';
import { getMultiLang } from '@platform/api';
import classnames from 'classnames'
import { config as CONFIG } from '@platform/api';
// import datajson from '../../../../demo/liuxi/billtrack/data.json'

require('./index.less');

export default class BillErrorTrack extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toShowBillTraskInfoTable: true, //是否显示上下游信息
            dagreData: [],
            tableData: [],
            tableColumns: [],
            show: this.props.show || false,
            showTrack: true,
            json: {},
            entered: false, //模态框显示完成
            showBackBtn: true,
            showResetBtn: true,
            centerId: '',
            errorViewType: this.props.errorViewType,
            hiddenCheckbox: false,
        };

        this.notShowTrack = false;
    }

    UNSAFE_componentWillMount() {
        getMultiLang({ moduleId: 'container_billErrorTrack', callback: this.jsonCallBack }); // moduleId为所需加载json文件夹名称前缀
        let { show, pk, type, gtxid, errorViewType, fromToastTip } = this.props;
        if (show) {
            this.getData(pk, type, false, gtxid, errorViewType, fromToastTip)
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        let { show, pk, type, gtxid, errorViewType, fromToastTip } = nextProps;
        let { show: oldShow } = this.props;
        if (show !== oldShow && oldShow === false) {
            this.getData(pk, type, false, gtxid, errorViewType, fromToastTip)
        }
    }

    componentDidMount() {
        this.forceUpdate();
    }

    //请求数据
    getData = (pk, type, extract, gtxid, errorViewType, fromToastTip, data) => {
        console.log('是否有发ajax', pk, type, errorViewType !== 'none')
        if (pk && type && errorViewType !== 'none') {
            let modulecode = ''
            ajax({
                url: '/nccloud/riart/billFlow/billFlowQueryModuleOfBilltype.do',
                data: { billOrTransType: type },
                success: res => {
                    if (res.data) {
                        modulecode = res.data.modulecode ? '/' + res.data.modulecode : ''

                        //查询追溯数据
                        ajax({
                            url: `/nccloud${modulecode}/riart/billFlow/billFlowAction.do`,
                            data: {
                                queryCondition: {
                                    bill_PK: pk,
                                    bill_type: type,
                                },
                            },
                            success: res => {
                                console.log('是否有res', res, res.data)
                                if (res.data) {
                                    this.setState({
                                        dagreData: res.data,
                                        show: this.props.show,
                                        extract,
                                        centerId: pk,
                                        selectId: pk,
                                        selectType: type,
                                        showTrack: true,
                                    });
                                } else {
                                    //出错时，不显示追溯图
                                    this.setState({
                                        showTrack: false,
                                        hiddenCheckbox: true,
                                    });
                                }
                            },
                            error: err => {
                                console.error('是否出错', err)
                                if (err) {
                                    console.error(err.message);
                                    //出错时，不显示追溯图
                                    this.setState({
                                        showTrack: false,
                                        hiddenCheckbox: true,
                                    });
                                }
                            },
                        });
                    }
                },
            })
        }

        if (gtxid) {
            //查询错误原因
            ajax({
                url: '/nccloud/platform/fixdata/FixDataByGtxidAction.do',
                data: { gtxid },
                success: res => {
                    if (res.data) {
                        let resData = res.data;
                        resData.index = 1;
                        if (fromToastTip && typeof resData.billNo === 'string') {
                            if (Array.from(new Set(resData.billNo.split(','))).length > 1) {
                                this.notShowTrack = true;
                            }
                        }
                        if (resData) {
                            if (this.notShowTrack) {
                                this.setState({
                                    tableData: [resData],
                                    show: this.props.show,
                                    hiddenCheckbox: true,
                                    errorViewType: 'none',
                                    showBackBtn: resData.compensable === '1', 
                                    showResetBtn: resData.retry === '1'
                                });
                            } else {
                                this.setState({
                                    tableData: [resData],
                                    show: this.props.show,
                                    errorViewType: errorViewType,
                                    showBackBtn: resData.compensable === '1',
                                    showResetBtn: resData.retry === '1'
                                });
                            }
                        }
                    }

                },
                error: err => {
                    if (err) {
                        console.error(err);
                        toast({ color: 'danger', content: JSON.stringify(err.message) });
                        this.closeBillTrack();
                    }
                },
            });
        }
    }

    // 加载多语json
    jsonCallBack = (json, bool) => {
        if (bool) {
            let tableColumns = [
                {
                    title: <span fieldid={getSysFieldid('index')}>{json['0006']}</span>,
                    dataIndex: 'index',
                    key: 'index',
                    width: 70,
                    render: text => <span fieldid={getSysFieldid('index')} > {text}</ span>,
                },
                {
                    title: <span fieldid={getSysFieldid('errorMsg_desc')}>{json['0007']}</span>,
                    dataIndex: 'errorMsg_desc',
                    key: 'errorMsg_desc',
                    width: 150,
                    render: text => (
                        <div fieldid={getSysFieldid('errorMsg_desc')} >
                            <Tooltip
                                trigger="hover"
                                inverse
                                className="billtrack-table-tooltip"
                                placement="top"
                                overlay={text}
                            >
                                <span className="bill-table-ellipsis">{text}</span>
                            </Tooltip>
                        </div>
                    ),
                },
                {
                    title: <span fieldid={getSysFieldid('billNo')}>{json['0008']}</span>,
                    dataIndex: 'billNo',
                    key: 'billNo',
                    width: 150,
                    render: text => {
                        // 去重？？？ 可真难
                        text = Array.from(new Set(text && text.split(','))).join(',');
                        return (
                            <div fieldid={getSysFieldid('billNo')} >
                                <Tooltip
                                    trigger="hover"
                                    inverse
                                    className="billtrack-table-tooltip"
                                    placement="top"
                                    overlay={text}
                                >
                                    <span className="bill-table-ellipsis" >{text}</span>
                                </Tooltip>
                            </div>
                        )
                    },
                },
                {
                    title: <span fieldid={getSysFieldid('billtype_name')}>{json['0009']}</span>,
                    dataIndex: 'billtype_name',
                    key: 'billtype_name',
                    width: 150,
                    render: text => (
                        <div fieldid={getSysFieldid('billtype_name')} >
                            <Tooltip
                                trigger="hover"
                                inverse
                                className="billtrack-table-tooltip"
                                placement="top"
                                overlay={text}
                            >
                                <span className="bill-table-ellipsis">{text}</span>
                            </Tooltip>
                        </div>
                    ),
                },
                {
                    title: <span fieldid={getSysFieldid('operation')}>{json['0010']}</span>,
                    dataIndex: 'operation',
                    key: 'operation',
                    width: 150,
                    render: text => (
                        <div fieldid={getSysFieldid('operation')} >
                            <Tooltip
                                trigger="hover"
                                inverse
                                className="billtrack-table-tooltip"
                                placement="top"
                                overlay={text}
                            >
                                <span className="bill-table-ellipsis">{text}</span>
                            </Tooltip>
                        </div>
                    ),
                },
                {
                    title: <span fieldid={getSysFieldid('businessDate')}>{json['0011']}</span>,
                    dataIndex: 'businessDate',
                    key: 'businessDate',
                    width: 150,
                    render: text => (
                        <div fieldid={getSysFieldid('businessDate')} >
                            <Tooltip
                                trigger="hover"
                                inverse
                                className="billtrack-table-tooltip"
                                placement="top"
                                overlay={billMoment && text && billMoment(text).format('YYYY-MM-DD')}
                            >
                                <span className="bill-table-ellipsis">{billMoment && text && billMoment(text).format('YYYY-MM-DD')}</span>
                            </Tooltip>
                        </div>
                    ),
                },
            ];
            this.setState(
                {
                    json,
                    tableColumns,
                },
            );
        }
    }

    /**
     * 关闭单据追溯弹框
     */
    closeBillTrack = () => {
        this.props.close && this.props.close();
        this.setState({
            show: false,
            entered: false,
            //关闭单据追溯时，把显示table去掉
            toShowBillTraskInfoTable: true, // 默认要显示table 避免再次弹窗出来之后  状态不对
        });
    };

    /**
     * 单据追溯图的节点显示的单据名称和单据编号超的长度过长处理：
     * 	a单据标题极值10个字符，超出...。
            b单据编号极值16个字符，超出折行，超过两行...
            c存在...隐藏更多信息，鼠标移入展示全部内容，移出气泡范围隐藏。
            d长 宽 高固定，宽136px，高50px。标题字号13，编码字号12。元素样式美化
    */
    suitableLableText = (billTypeName, billCode, transTypeName, isShowTranstypeName, userDefShow) => {
        let billTypeNameText,
            userDefShowText,
            transTypeNameText;
        billCode = ellipsisText(billCode, 20);
        userDefShowText = ellipsisText(userDefShow, 20);
        if (isShowTranstypeName === 'Y' && transTypeName) {
            //单据标题极值10个字符，超出..
            transTypeNameText = ellipsisText(transTypeName, 20);
            return {
                title: transTypeNameText || transTypeName,
                billno: `${billCode || ''}`,
            }
        } else {
            //单据标题极值10个字符，超出..
            billTypeNameText = ellipsisText(billTypeName, 20);
            return {
                title: billTypeNameText || billTypeName,
                billno: `${billCode || ''}`,
                userDefShowText: userDefShowText,
            }
        }

    };

    /**
    * 格式化单据追溯渲染的数据
    */
    dataFormat = data => {
        let { json } = this.state;
        let { pk } = this.props;
        return data.map(item => {
            let { lightBillVO, sourceList, forwardList, isForward } = item;
            let { billID, billType, transtype, billTypeName = '', billCode, saga_status = '0', isShowTranstypeName, transTypeName, userDefFieldName, userDefShow } = lightBillVO;
            let data = this.suitableLableText(billTypeName, billCode, transTypeName, isShowTranstypeName, userDefShow);
            return {
                title: data.title,
                label: json['0018'] || '单据编号', //单据编号
                billno: data.billno,
                tooltipLabel: isShowTranstypeName ? json['0030'] || '交易类型' : json['0017'] || '单据名称',
                id: billID,
                userDefShow,
                userDefName: userDefFieldName,
                userDefShowText: data.userDefShowText,
                type: billType,
                isOrigin: pk === billID,
                transtype,
                source: sourceList || [],
                target: forwardList || [],
                isForward,
                billCode,
                billTypeName,
                saga_status,
                isShowTranstypeName,
                transTypeName,
            };
        });
    };

    /**
     * 双击单据打开新页面
     */
    onSelect = (selectId, type, transtype) => {
        let t = transtype || type;
        let modulecode = ''
        ajax({
            url: '/nccloud/riart/billFlow/billFlowQueryModuleOfBilltype.do',
            data: { billOrTransType: type },
            success: res => {
                if (res.data) {
                    modulecode = res.data.modulecode ? '/' + res.data.modulecode : ''

                    ajax({
                        url: `/nccloud${modulecode}/riart/billFlow/billFlowUrlAction.do`,
                        method: 'post',
                        data: {
                            billpk: selectId,
                            billtypecode: t,
                            pagecode: null,
                            sence: '4',
                        },
                        async: false,
                        success: result => {
                            //查到以后校验
                            if (result.success && result.data && result.data.appPageVO) {
                                let url = '';
                                if (result.data.appPageVO.pageurl) {
                                    url = result.data.appPageVO.pageurl.replace('nccloud/resources/', '');
                                }
                                let newUrl = pageTo.getResPageUrl(url, {
                                    id: selectId,
                                    status: 'browse',
                                    scene: 'linksce',
                                });

                                let oldWinHash = '';
                                if (CONFIG.isPageModal) {
                                    oldWinHash = '?' + getAppUrl().pageurl;
                                } else {
                                    oldWinHash = getTopWindow().location.hash;
                                }

                                getTopWindow().openCheck(
                                    result.data.appcode,
                                    result.data.appPageVO.pagecode,
                                    (win, res, openWinCallBack) => {
                                        pageTo.checkCallBack({
                                            win, //打开页签window
                                            res, //后台返回应用信息
                                            path: newUrl, // 业务传递url
                                            appcode: result.data.appcode, 
                                            pagecode: result.data.appPageVO.pagecode, 
                                            type: 'open', //打开方式 'open' 'link' 'router'
                                            oldWinHash, //原来的参数
                                            params: {
                                                id: selectId,
                                                status: 'browse',
                                                scene: 'linksce',
                                            }, //业务传新参数
                                            openWinCallBack, 
                                        });
                                    },
                                    'tab',
                                );
                            }
                        },
                    });
                }
            },
        })
    };

    /**
     * 单据追溯图表格显示控制
     */
    isShowTrackBillTable = () => {
        let { toShowBillTraskInfoTable } = this.state;
        this.setState({
            toShowBillTraskInfoTable: !toShowBillTraskInfoTable,
            showTrack: false,
        }, () => {
            this.setState({ showTrack: true });
        });
    };

    //modal	显示完成后的钩子函数
    onEntered = () => {
        this.setState({ entered: true });
        let modalBody = document.querySelector('.u-modal-body');
        if (modalBody) {
            let tableBodyHeight = (document.body.clientHeight - 180) / 2;
            this.setState({ tableBodyHeight });
        }
    };

    //modal开始显示的回调
    onEntering = () => {
        let resizeWrap = document.querySelector('.modal-content-resizeWrap');
        let height = this.props.bodyClientHeight ? this.props.bodyClientHeight : document.body.clientHeight;
        this.maxWidth = document.body.clientWidth;
        this.maxHeight = height;
        this.minHeight = height - 60;
        if (resizeWrap) {
            resizeWrap.style.height = this.minHeight - 30 + 'px';
        }
    };

    //重试
    reSetError = () => {
        let { json = {} } = this.state,
            gtxid = this.props.gtxid;
        this.closeBillTrack();
        ajax({
            url: '/nccloud/platform/fixdata/ResetFixDataAction.do',
            data: { gtxid: [gtxid] },
            async: false,
            success: () => {
                toast({ mark: 'socketReSetErrorToast', color: 'success', content: json['0023'] });
            },
        });

    }

    //回退
    backError = () => {
        let { json = {} } = this.state,
            gtxid = this.props.gtxid;
        this.closeBillTrack();
        ajax({
            url: '/nccloud/platform/fixdata/BackFixDataAction.do',
            data: { gtxid },
            async: false,
            success: () => {
                toast({ mark: 'socketBackErrorToast', color: 'success', content: json['0024'] });
            },
        });
    }

    getSelectId = (selectedId, selectedType) => {
        this.setState({ tableData: this.state.tableData, selectId: selectedId, selectType: selectedType });
    };

    maxBillTrack = value => {
        this.setState({ max: value })
    }

    // 抽取路径按钮的点击事件
    extractionPathClick = () => {
        let { type, pk, gtxid, fromToastTip } = this.props;
        let { json, extract, selectId, selectType, errorViewType } = this.state;
        if (!extract) {
            if (selectId) {
                this.getData(selectId, selectType, true, gtxid, errorViewType, fromToastTip)
            } else {
                //请选择节点后再进行路径抽取
                toast({ color: 'warning', content: json['0012'] });
            }
        } else {
            this.getData(pk, type, false, gtxid, errorViewType, fromToastTip)
        }
    };

    render() {
        let {
            toShowBillTraskInfoTable, show, tableData,
            tableColumns, json, entered, showTrack, showBackBtn,
            showResetBtn, extract, dagreData, centerId, hiddenCheckbox, errorViewType, tableBodyHeight,
        } = this.state;
        let { type, pk } = this.props;
        // let extractBtns = [json['0013'], json['0014']]; //['显示全部','路径抽取']
        let tooltipText = [json['0017'], json['0018']]; //['单据名称','单据编号']
        let extractFieldId = extract ? 'show-all' : 'dagre-extract'
        let showG6 = entered && showTrack && type && dagreData.length && errorViewType !== 'none'
        if (showG6) { tableBodyHeight -= 30 } else {
            tableBodyHeight = tableBodyHeight * 2 - 15
        }
        return (
            <React.Fragment>
                {/* {this.state.max ? (show ? <MaxBox content={this.maxContent()} /> : null) : */}
                <Modal
                    fieldid="BillTrack"
                    className={`bill-track error-bill-track-hw ${show ? 'show-bill-track disabled-bg-btn' : 'hide-bill-track'}  `}
                    show={show}
                    onHide={this.closeBillTrack}
                    onEntered={this.onEntered}
                    onEntering={this.onEntering}
                    backdropClosable={false}
                    maxHeight={this.maxHeight}
                    maxWidth={this.maxWidth}
                    minHeight={this.minHeight}
                >
                    <Modal.Header className="title" fieldid="header-area" closeButton>
                        <span className="name" > {json['0001']}{/* 错误追溯 */}</span>
                        <span className='billtrack-header-space' />
                        {!hiddenCheckbox && errorViewType !== 'none' && (
                            <span className='billtrack-header-btn-group'>
                                <ButtonGroup style={{ margin: 10 }}>
                                    <Button
                                        fieldid={getSysFieldid('billtrack_graph')}
                                        colors={toShowBillTraskInfoTable ? 'secondary' : 'primary'}
                                        className='dnd-cancel'
                                        onClick={() => this.isShowTrackBillTable(false)}
                                    >{json['0029']} {/* 图形 */}</Button>
                                    <Button
                                        fieldid={getSysFieldid('upstream_and_downstream')}
                                        colors={toShowBillTraskInfoTable ? "primary" : 'secondary'}
                                        className='dnd-cancel'
                                        onClick={() => this.isShowTrackBillTable(true)}
                                    >{json['0028']}{/* 上下游 */} </Button>
                                </ButtonGroup>
                            </span>
                        )}

                        {!hiddenCheckbox && errorViewType !== 'none' && <span className='billtrack-header-single-btn'>
                            {/* 显示全部,路径抽取 */}
                            <Button
                                fieldid={getSysFieldid(extractFieldId)}
                                className='dnd-cancel'
                                onClick={this.extractionPathClick}
                            >{extract ? json['0013'] : json['0014']}</Button>
                        </span>}
                        {/* <span
                            className='billtrack-header-max iconfont icon-zuidahua dnd-cancel'
                            onClick={() => this.maxBillTrack(true)}
                        /> */}
                        <span
                            className='billtrack-header-close iconfont icon-guanbi dnd-cancel'
                            onClick={this.closeBillTrack}
                        />
                    </Modal.Header>
                    <Modal.Body>
                        {(showG6) ? (
                            <DagreChart
                                selectedId={pk}
                                extract={extract}
                                list={this.dataFormat(dagreData)}
                                getSelectId={this.getSelectId}
                                onSelect={this.onSelect}
                                centerId={centerId}
                                tooltipText={tooltipText}
                                size={toShowBillTraskInfoTable} //表格是否显示 Boolean
                                parentCom="BillTrack" //使用DagreChart的父组件的唯一标识【自定义即可】，为了解决DagreChart非单据追溯使用的时候首次加载未获取数据的问题
                            />
                        ) : null}
                        {toShowBillTraskInfoTable && (
                            <div fieldid={getSysFieldid('billTrack_table')} className="BillTraskTable-wrap">
                                <Table
                                    scroll={{ y: tableBodyHeight || '160px' }}
                                    columns={tableColumns}
                                    data={tableData}
                                    className="BillTraskTable"
                                    bodyStyle={{ height: tableBodyHeight || '160px' }}
                                    style={{ height: 'calc(100% - 30px)' }}
                                />
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <HotKeys
                            keyMap={{
                                sureBtnHandler: 'Alt+Y',
                                cancelBtnHandler: 'Alt+N',
                            }}
                            handlers={{
                                sureBtnHandler: () => {
                                    this.reSetError();
                                },
                                cancelBtnHandler: () => {
                                    this.backError();
                                },
                            }}
                            className="billerrortrack-hotkeys-wrapper"
                            focused={true}
                            attach={document.body}
                            display="inline"
                        />
                        {showResetBtn && (
                            <Tooltip
                                placement="top"
                                inverse
                                overlay={`${json['0025']}  (Alt+Y)`}
                                trigger={['focus', 'hover']}
                                className="model-helper-overlay"
                            >
                                <Button onClick={this.reSetError} colors="primary" style={{ marginRight: 8 }}>{json['0025']}(<span className="text-decoration-underline">Y</span>)</Button>
                            </Tooltip>
                        )}
                        {showBackBtn && (
                            <Tooltip
                                placement="top"
                                inverse
                                overlay={`${json['0026']}  (Alt+N)`}
                                trigger={['focus', 'hover']}
                                className="model-helper-overlay"
                            >
                                <Button onClick={this.backError} colors="secondary" style={{ marginRight: 8 }}>{json['0026']}(<span className="text-decoration-underline">N</span>)</Button>
                            </Tooltip>
                        )}
                        <Tooltip
                            placement="top"
                            inverse
                            overlay={`${json['0027']}  (Esc)`}
                            trigger={['focus', 'hover']}
                            className="model-helper-overlay"
                        >
                            <Button onClick={this.closeBillTrack} bordered>{json['0027']}</Button>
                        </Tooltip>
                    </Modal.Footer>
                </Modal>
                {/* } */}
            </React.Fragment>
        );
    }
}
